var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-text text-left"},[_c('svg',{staticClass:"error-icon"},[_c('use',{attrs:{"xlink:href":"/svg/feather-sprite.svg#zap"}})]),_vm._v(" "+_vm._s(_vm.errortext)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }